import { render, staticRenderFns } from "./MatchLetterStep.vue?vue&type=template&id=04bed270&scoped=true"
import script from "./MatchLetterStep.vue?vue&type=script&lang=js"
export * from "./MatchLetterStep.vue?vue&type=script&lang=js"
import style0 from "./MatchLetterStep.vue?vue&type=style&index=0&id=04bed270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bed270",
  null
  
)

export default component.exports